// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7f36494","239":"f147607e","732":"4bf0ec0d"}[chunkId] + ".chunk.js";
};